module.exports = __webpack_public_path__ + "img/dollar-icon-luxliebe.e29f1775.svg";